import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { ConfigService } from '../../services/config/config.service';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {
  constructor(
    public userService: UserService,
    private configService: ConfigService,
    private sanitizer: DomSanitizer,
  ) {}

  public lostPetPhoneNumber = this.configService.getTextFromKey('phone-number-for-member');
  public companyPhoneNumber = this.configService.getTextFromKey('company-phone-number');
  public address = this.configService.getTextFromKey('contact-us-address');
  public email = this.configService.getTextFromKey('contact-email-address');
  public contactUsDescriptionHtml!: SafeHtml;

  ngOnInit() {
    this.contactUsDescriptionHtml = this.sanitizer.bypassSecurityTrustHtml(
      this.configService.getTextFromKey('contact-us-description'),
    );
  }
}
